import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import { getTimezones } from './timezones.api';

const name = 'timezones';

export const fetchTimezones = createAsyncThunkFromFetch(`${name}/fetchTimezones`, getTimezones);
